import { MutableRefObject } from 'react';

export const getElementWidth = (ref: MutableRefObject<HTMLElement | null>): number => {
  if (ref?.current) {
    return ref.current.offsetWidth;
  }
  return 0;
};
